var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.loading)?_c('div',{staticClass:"spinner w-100"}):_vm._e(),_c('div',{staticClass:"d-flex justify-center"},[_c('Chart',{staticClass:"chart",attrs:{"options":_vm.chartOptions,"series":_vm.series,"type":"pie"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }